import fetch from "auth/FetchInterceptor";
import requestCacheService from "./RequestCacheService";

const cupomService = {};

cupomService.get = async function (params = {}) {
	const {
		page = 0,
		pageSize = 5,
		search = "",
		orderBy = "id",
		orderDirection = "asc",
		filters = {},
	} = params;

	const queryParams = {
		page,
		pageSize,
		search,
		orderBy,
		orderDirection,
		filters,
	};

	return fetch({
		url: "/v1/rest/cupom",
		method: "get",
		params: queryParams,
		headers: { is_paginated: true },
	});
};

cupomService.getAll = async function () {
	return requestCacheService.cacheRequest(
		"lista_cupom",
		() => {
			return fetch({
				url: "/v1/rest/cupom",
				method: "get",
			});
		},
		300,
	);
};

cupomService.post = async function (values) {
	await requestCacheService.limparCache("lista_cupom");
	return fetch({
		url: "/v1/rest/cupom",
		method: "post",
		data: values,
	});
};

cupomService.put = async function (values, id) {
	return fetch({
		url: "/v1/rest/cupom/" + id,
		method: "put",
		data: values,
	});
};

cupomService.getById = async (id) => {
	return fetch({
		url: `/v1/rest/cupom/${id}`,
		method: "get",
	});
};

cupomService.delete = async (id) => {
	return fetch({
		url: `/v1/rest/cupom/${id}`,
		method: "delete",
	});
};

/**
 * Relatório de uso de um cupom: { cupom, resumo, usos[] }.
 */
cupomService.getUsos = async (id) => {
	return fetch({
		url: `/v1/rest/cupom/${id}/usos`,
		method: "get",
	});
};

/**
 * Validar um código de cupom
 * @param {string} codigo - Código do cupom a ser validado
 * @returns {Promise} - Promessa com os dados do cupom se for válido
 */
cupomService.validarCupom = async (codigo) => {
	return fetch({
		url: "/v1/rpc/validar-cupom",
		method: "post",
		data: { codigo },
	});
};

/**
 * Retorna o cupom ativo do usuário logado (ou null se não tiver nenhum).
 * Resposta: { codigo, porcentagem_desconto, quantidade_meses, data_resgate, data_limite }
 */
cupomService.obterMeuCupom = async () => {
	return fetch({
		url: "/v1/rpc/meu-cupom",
		method: "get",
	});
};

/**
 * Resgata um cupom para o usuário logado.
 */
cupomService.resgatarCupom = async ({ codigo, origem } = {}) => {
	return fetch({
		url: "/v1/rpc/resgatar-cupom",
		method: "post",
		data: { codigo, origem },
	});
};

export default cupomService;
